import React, { useId } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Typography from '@mui/material/Typography';
import Button from '@/components/Button/Button';
import { monthMapper, reduceTokenString } from '@/common/utils/app.utils';
import tokens from '@/components/AppDialog/tokens.json';
import useGetPeriodTotals from '@/hooks/useGetPeriodTotals';

interface SubmitBatchConfirmationDialogProps {
  open: boolean;
  numericPeriod: string;
  readablePeriod: string;
  setPrimaryButtonVisibility: (mode: boolean) => void;
  onConfirm: () => void;
}

function SubmitBatchConfirmationDialog({
  open,
  setPrimaryButtonVisibility: setVisibility,
  numericPeriod,
  readablePeriod,
  onConfirm,
}: SubmitBatchConfirmationDialogProps) {
  const title = reduceTokenString(tokens.CONFIRM_SUBMIT, readablePeriod);
  const readableMonth = readablePeriod.split(' ')[0];
  if (!Object.values(monthMapper).includes(readableMonth)) {
    throw new Error(`Invalid month name ${readableMonth}`);
  }

  const dialogId = useId();
  const { employeeRecords, psp, contributions, ataFees } = useGetPeriodTotals(numericPeriod);

  return (
    <Dialog open={open} fullWidth maxWidth="sm" aria-labelledby={dialogId}>
      <DialogTitle id={dialogId} variant="h5" fontWeight="600">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText component="span">
          <Typography>
            {`Are you sure all ${readableMonth} data is included in this batch? It is not possible to resubmit
            the batch after it is accepted.`}
          </Typography>
          <br />
          <Typography>
            If you are trying to submit an ERTN, it must be submitted separately on the ERTN page.
          </Typography>
          <br />
          <Typography>Employees: {employeeRecords}</Typography>
          <Typography>PSP: {psp}</Typography>
          <Typography>Contributions: {contributions}</Typography>
          <Typography>ATA Fees: {ataFees}</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={() => setVisibility(false)}>
          Cancel
        </Button>
        <Button onClick={onConfirm}>Yes, Submit</Button>
      </DialogActions>
    </Dialog>
  );
}

export default SubmitBatchConfirmationDialog;
